import { AddButtonDialog } from './add-button-dialog.component';
import { AddButtonSetDialog } from './add-buttonset-dialog.component';
import { EditButtonDialog } from './edit-button-dialog.component';
import { EditButtonSetDialog } from './edit-buttonset-dialog.component';

export const dialogs: any[] = [
  AddButtonDialog,
  AddButtonSetDialog,
  EditButtonDialog,
  EditButtonSetDialog
];

export * from './add-button-dialog.component';
export * from './add-buttonset-dialog.component';
export * from './edit-button-dialog.component';
export * from './edit-buttonset-dialog.component';
